'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Email$() {
  this.c6i = null;
  this.c6j = false;
  this.c6g = null;
  this.c6h = false;
  this.c6m = null;
  this.c6n = false;
  this.c6k = null;
  this.c6l = false;
  this.c6c = null;
  this.c6d = false;
  this.c6e = null;
  this.c6f = false;
  this.c6o = null;
  this.c6p = false;
  this.c6b = null;
  $n_Lpresto_types$Email$ = this;
  this.c6b = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_matching_Regex(), "^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
}
export { $c_Lpresto_types$Email$ as $c_Lpresto_types$Email$ };
$p = $c_Lpresto_types$Email$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Email$;
/** @constructor */
function $h_Lpresto_types$Email$() {
}
export { $h_Lpresto_types$Email$ as $h_Lpresto_types$Email$ };
$h_Lpresto_types$Email$.prototype = $p;
$p.p8 = (function() {
  if ((!this.c6j)) {
    this.c6i = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c6j = true;
  }
  return this.c6i;
});
$p.cG = (function() {
  if ((!this.c6h)) {
    this.c6g = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c6h = true;
  }
  return this.c6g;
});
$p.sF = (function() {
  if ((!this.c6n)) {
    this.c6m = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c6n = true;
  }
  return this.c6m;
});
$p.r5 = (function() {
  if ((!this.c6l)) {
    this.c6k = new $c_Lpresto_types$Email$$anon$68(this);
    this.c6l = true;
  }
  return this.c6k;
});
$p.cs1 = (function() {
  if ((!this.c6d)) {
    this.c6c = new $c_Lpresto_types$Email$$anon$69(this);
    this.c6d = true;
  }
  return this.c6c;
});
$p.cHI = (function() {
  if ((!this.c6f)) {
    this.c6e = new $c_Lpresto_types$Email$$anon$70(this);
    this.c6f = true;
  }
  return this.c6e;
});
$p.zj = (function() {
  if ((!this.c6p)) {
    this.c6o = new $c_Lpresto_types$Email$$anon$71(this);
    this.c6p = true;
  }
  return this.c6o;
});
$p.a3u = (function(text) {
  var trimmed = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(text);
  var at = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__indexOf__I__I(trimmed, 64);
  return ((trimmed.length > 254) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (("Email too long: '" + trimmed) + "'"))) : (((at <= 0) || (at > 64)) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (("Invalid email: '" + trimmed) + "'"))) : ((!this.c6b.aej(trimmed)) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (("Invalid email: '" + trimmed) + "'"))) : ($m_Lpresto_types$Email$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(trimmed)))));
});
var $d_Lpresto_types$Email$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Email$, "presto.types$Email$", ({
  ZN: 1,
  D: 1
}));
export { $d_Lpresto_types$Email$ as $d_Lpresto_types$Email$ };
var $n_Lpresto_types$Email$;
function $m_Lpresto_types$Email$() {
  if ((!$n_Lpresto_types$Email$)) {
    $n_Lpresto_types$Email$ = new $c_Lpresto_types$Email$();
  }
  return $n_Lpresto_types$Email$;
}
export { $m_Lpresto_types$Email$ as $m_Lpresto_types$Email$ };
/** @constructor */
function $c_Lpresto_types$Email$$anon$71(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Email$$anon$71 as $c_Lpresto_types$Email$$anon$71 };
$p = $c_Lpresto_types$Email$$anon$71.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Email$$anon$71;
/** @constructor */
function $h_Lpresto_types$Email$$anon$71() {
}
export { $h_Lpresto_types$Email$$anon$71 as $h_Lpresto_types$Email$$anon$71 };
$h_Lpresto_types$Email$$anon$71.prototype = $p;
$p.bn = (function(it) {
  try {
    $m_Lpresto_types$Email$();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bN = (function(text) {
  return $m_Lpresto_types$Email$().a3u(text);
});
$p.bJ = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$Email$$anon$71 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Email$$anon$71, "presto.types$Email$$anon$71", ({
  ZR: 1,
  K: 1
}));
export { $d_Lpresto_types$Email$$anon$71 as $d_Lpresto_types$Email$$anon$71 };
/** @constructor */
function $c_Lpresto_types$Email$$anon$69(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Email$$anon$69 as $c_Lpresto_types$Email$$anon$69 };
$p = $c_Lpresto_types$Email$$anon$69.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Conversion();
$p.constructor = $c_Lpresto_types$Email$$anon$69;
/** @constructor */
function $h_Lpresto_types$Email$$anon$69() {
}
export { $h_Lpresto_types$Email$$anon$69 as $h_Lpresto_types$Email$$anon$69 };
$h_Lpresto_types$Email$$anon$69.prototype = $p;
$p.v = (function(x) {
  $m_Lpresto_types$Email$();
  $m_Lpresto_types$Email$();
  return x;
});
var $d_Lpresto_types$Email$$anon$69 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Email$$anon$69, "presto.types$Email$$anon$69", ({
  ZP: 1,
  cz: 1,
  t: 1
}));
export { $d_Lpresto_types$Email$$anon$69 as $d_Lpresto_types$Email$$anon$69 };
/** @constructor */
function $c_Lpresto_types$Email$$anon$70(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Email$$anon$70 as $c_Lpresto_types$Email$$anon$70 };
$p = $c_Lpresto_types$Email$$anon$70.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Conversion();
$p.constructor = $c_Lpresto_types$Email$$anon$70;
/** @constructor */
function $h_Lpresto_types$Email$$anon$70() {
}
export { $h_Lpresto_types$Email$$anon$70 as $h_Lpresto_types$Email$$anon$70 };
$h_Lpresto_types$Email$$anon$70.prototype = $p;
$p.v = (function(x) {
  $m_Lpresto_types$Email$();
  $m_Lpresto_types$Email$();
  return x;
});
var $d_Lpresto_types$Email$$anon$70 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Email$$anon$70, "presto.types$Email$$anon$70", ({
  ZQ: 1,
  cz: 1,
  t: 1
}));
export { $d_Lpresto_types$Email$$anon$70 as $d_Lpresto_types$Email$$anon$70 };
/** @constructor */
function $c_Lpresto_types$Email$$anon$68(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Email$$anon$68 as $c_Lpresto_types$Email$$anon$68 };
$p = $c_Lpresto_types$Email$$anon$68.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Email$$anon$68;
/** @constructor */
function $h_Lpresto_types$Email$$anon$68() {
}
export { $h_Lpresto_types$Email$$anon$68 as $h_Lpresto_types$Email$$anon$68 };
$h_Lpresto_types$Email$$anon$68.prototype = $p;
$p.cA = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cy = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.cq = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.cr = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cI = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cz = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b4 = (function(x, y) {
  $m_Lpresto_types$Email$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__compareTo__T__I(x, y);
});
var $d_Lpresto_types$Email$$anon$68 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Email$$anon$68, "presto.types$Email$$anon$68", ({
  ZO: 1,
  O: 1,
  a: 1,
  Q: 1,
  U: 1,
  W: 1
}));
export { $d_Lpresto_types$Email$$anon$68 as $d_Lpresto_types$Email$$anon$68 };
//# sourceMappingURL=presto.types$-Email$.js.map
